import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { cancelFormName } from '../Constants/constants';
import refundCancelInitialFormValues from '../Constants/refundCancelInitialFormValues';
import RefundCancel from '../Components/RefundsCancellations/RefundsCancellations';
import { cancelPolicy as cancelPolicyAction } from '../Actions/actions';

const formValues = formValueSelector(cancelFormName);

const RefundsCancellationsContainer = reduxForm({
  form: cancelFormName,
  initialValues: refundCancelInitialFormValues(),
})(RefundCancel);

const mapStateToProps = (state) => ({
  waiting: state.refundCancelPage.waiting,
  disabled: state.refundCancelPage.disabled,
  policyCancelled: state.refundCancelPage.policyCancelled,
  referenceNumber: state.refundCancelPage.referenceNumber,
  policyNumber: state.refundCancelPage.policyNumber,
  contactEmail: state.refundCancelPage.contactEmail,
  cancelPolicyNumber: formValues(state, 'cancelPolicyNumber'),
  cancelCreditCard: formValues(state, 'cancelCreditCard') || '',
  cancelZip: formValues(state, 'cancelZip'),
});

const mapDispatchToProps = (dispatch) => ({
  cancelPolicy: (policyNumber, creditCardNumber, venueZip, handleShow) =>
    dispatch(
      cancelPolicyAction(policyNumber, creditCardNumber, venueZip, handleShow),
    ),
});

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  cancelPolicy: (handleShow) =>
    dispatchProps.cancelPolicy(
      stateProps.cancelPolicyNumber,
      stateProps.cancelCreditCard,
      stateProps.cancelZip,
      handleShow,
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(RefundsCancellationsContainer);
